<div class="container-fluid p-3">
     <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <!-- <h4 class="mb-1">
         {{
    schemeType === 'makeI'
      ? 'Shortlisting of firms'
      : schemeType === 'tdf' || schemeType == 'idex'
        ? 'Cost Negotiation'
        : 'Commercial Negotiation'
  }}
        </h4> -->
        <h4>{{ 'CNC (Procurment) MOM Upload' }}</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
            >
            {{
              stepDetails?.step_status == 0
                ? "INITIATION PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container
          *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            stepDetails?.can_edit ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          "
        >
          <button
            class="btn btn-primary me-2"
            (click)="routeConfig.emit({isRouteConfig: true})"
            
          >
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <!-- <div class="row mb-4">
        <div class="col-md-6">
            <div class="card p-3">
                <h5>Commercial Negotiation Document</h5>
                <p class="text-muted">Upload the Commercial Negotiation Document</p>
                <p-fileUpload mode="basic"  #fileUpload chooseLabel="Upload Commercial Negotiation Document" 
                    [auto]="true"   [customUpload]="true" [multiple]="false" (uploadHandler)="onUpload($event)"
                    styleClass="p-button-outlined w-100">
                </p-fileUpload>
                <div class="mt-3" *ngIf="selectedFile?.name">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{extractFileName(selectedFile.name)}}</span>
                         <button class="btn btn-sm" (click)="clearUpload(fileUpload)">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </div>
                <div class="mt-3" *ngIf="filePathFromApi">
                    <div class="d-flex justify-content-between align-items-center">
                         <a [href]="apiUrl + filePathFromApi" target="_blank"> {{ extractFileName(filePathFromApi) }}</a>
                        <div class="d-flex gap-2">
                          <a [href]="apiUrl + filePathFromApi" target="_blank">
                            <p-button icon="pi pi-eye" styleClass="p-button-sm p-button-outlined"
                                pTooltip="View Document"></p-button>
                                </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div> -->


  <!-- <form [formGroup]="commentForm">
        <div class="mb-4 editor-container">
            <label class="mb-2 d-block">Justification<b class="text-danger">*</b> <span *ngIf="commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched" class="text-danger mt-1">
                comment is required
            </span></label> -->

  <!-- <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor> -->
  <!-- <editor [init]="init" formControlName="comment"  [disabled]="isEditorDisabled" ></editor>
            
        </div> -->
  <!-- <p-button label="submit" [outlined]="true" icon="pi pi-save" (click)="onSubmit()"></p-button> -->
  <!-- </form> -->

  <div>
    <!-- <div class="mt-3 mb-3 d-flex justify-content-end" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">
    <button pButton label="Qualify Vendor" (click)="submitSelectedVendor()" [disabled]="!selectedVendor"
      class="p-button-sm p-button-info"></button>
     </div> -->
    <p-table *ngIf="schemeType !== 'tdf'" [value]="vendors" editMode="row" dataKey="id" #table>
      <ng-template pTemplate="header">
        <tr>
          <th>Vendor Name</th>
          <th *ngIf="schemeType != 'makeI' && schemeType != 'idex' ">Vendor Address</th>
          <th>{{schemeType == 'rev' ? 'Cost' : 'Budgetory Quote'}}</th>
          <th>Level</th>
          <th>Final Price</th>
           <th *ngIf="schemeType == 'rev'">
              Commercial Negotiation held on
            </th>
          <th *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="rowData">
          <td>{{ rowData.vendor.name }}</td>
          <td *ngIf="schemeType != 'makeI' && schemeType != 'idex'">{{ rowData.vendor.address }}</td>

          <!-- Benchmark Price -->
          <td>
            <!-- <p-cellEditor>
              <ng-template pTemplate="input">
                <input type="number" pInputText [(ngModel)]="rowData.budget" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ rowData.budget}}
              </ng-template>
            </p-cellEditor> -->
            {{ rowData.budget}}
          </td>

          <!-- Level -->
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input type="text" pInputText [(ngModel)]="rowData.level" [ngModelOptions]="{ standalone: true }"
                    pattern="^L[1-9][0-9]*$" (blur)="validateLevel(rowData)" placeholder="L1, L2, L3..." disabled />
              </ng-template>
              <ng-template pTemplate="output">
                {{ rowData.level }}
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            <ng-container *ngIf="table.isRowEditing(rowData); else readOnly">
              <input type="number" pInputText [(ngModel)]="rowData.finalPrice" />
            </ng-container>
            <ng-template #readOnly>
              <span>{{ rowData.finalPrice }}</span>
            </ng-template>
          </td>
           <td pEditableColumn *ngIf="schemeType == 'rev'">
              <ng-container *ngIf="editing; else viewMode">
                <input type="date" pInputText [(ngModel)]="rowData.date" />
              </ng-container>
              <ng-template #viewMode>
                {{ rowData.date }}
              </ng-template>
            </td>


          <!-- Actions -->
          <td class="min-wid-150"
            *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">

            <button *ngIf="!editing" pButton icon="pi pi-pencil" (click)="table.initRowEdit(rowData)"
              class="p-button-text"></button>

            <button *ngIf="editing" pButton icon="pi pi-check" (click)="onRowEditSave(rowData)"
              class="p-button-text p-button-success"></button>

            <button *ngIf="editing" pButton icon="pi pi-times" (click)="table.cancelRowEdit(rowData)"
              class="p-button-text p-button-danger"></button>

            <button *ngIf="!editing" pButton icon="pi pi-trash" (click)="openDeleteDialog(rowData)"
              class="p-button-text p-button-danger"></button>
          </td>


        </tr>
      </ng-template>
    </p-table>
      <!-- Document Upload Section -->
  <div class="row mb-4 mt-4">
    <app-upload-document [title]="'Documents Upload'" [isEditable]="stepDetails?.can_edit"></app-upload-document>
    
  </div>
  </div>

  <div class="mt-4">
    <form [formGroup]="commentForm">
      <!-- <div class="form-group mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
        <label for="pdsTitle"><strong>• Justification</strong></label>
       
        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      </div> -->
      <div class="editor-field">
            <b class="form-label-left">Remark</b>
            <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>

    </form>
  </div>
</div>


<p-dialog header="Confirm Delete" [(visible)]="showDeleteDialog" [modal]="true" [closable]="true" appendTo="body"
  [style]="{width: '400px'}" [maximizable]="true">
  <div class="p-3">
    <p>Are you sure you want to delete vendor "<strong>{{ selectedRow?.vendor?.name }}</strong>"?</p>
  </div>
  <div class="p-dialog-footer">
    <button pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="showDeleteDialog = false"></button>
    <button pButton label="Delete" icon="pi pi-trash" class="p-button-danger" (click)="confirmDelete()"></button>
  </div>
</p-dialog>


<!-- <p-toast position="top-center" key="confirm" (onClose)="onReject()" [baseZIndex]="9999">
  <ng-template let-message pTemplate="message">
      <div class="container-fluid">
          <div class="row mb-3">
              <div class="col-12">
                  <div class="font-medium text-lg my-3 text-900">
                      {{ message.summary }}
                  </div>
              </div>
          </div>
          
          <div class="row mb-3 justify-content-center">
            <div class="col-12 d-flex align-items-center justify-content-center" style="gap: 8px;">
              <p-checkbox [(ngModel)]="confirmChecked" binary="true" inputId="confirmCb"></p-checkbox>
              <b for="confirmCb" class="ms-2 mb-0 cursor-pointer d-flex align-items-center">
                This is final approval
              </b>
            </div>
          </div>
          
          <div class="row">
              <div class="col-12 d-flex align-items-center justify-content-between gap-2">
                  <button size="small" label="Confirm" class="btn btn-success"  (click)="onConfirm()"><i class="pi pi-check-circle"></i>  Submit</button>
                  
                   <button size="small" label="Cancel" class="btn btn-info" (click)="routeconfig()"><i class="pi pi-times-circle"></i> Route Config </button>
              </div>
          </div>
      </div>
  </ng-template>
</p-toast> -->
